// Centralized environment configuration (CRA)
// CRA exposes only REACT_APP_* variables; these values are baked at build time.

function readEnv(key, fallback = "") {
  const env = typeof process !== "undefined" && process?.env ? process.env : {};
  return String(env[key] || fallback || "").trim();
}

function readBoolEnv(key, fallback = false) {
  const raw = readEnv(key, fallback ? "true" : "false").toLowerCase();
  return raw === "true" || raw === "1" || raw === "yes" || raw === "on";
}

const IS_PROD_BUILD = process.env.NODE_ENV === "production";

function isLocalHost(hostname = "") {
  const h = String(hostname || "").toLowerCase();
  return h === "localhost" || h === "127.0.0.1" || h === "0.0.0.0" || h.endsWith(".local");
}

function isReactSnapRuntime() {
  return typeof navigator !== "undefined" && /ReactSnap/i.test(String(navigator.userAgent || ""));
}

function getCurrentOrigin() {
  if (typeof window === "undefined") return "";
  try {
    return window.location.origin || "";
  } catch {
    return "";
  }
}

function guessApiBaseUrl() {
  const explicit = readEnv("REACT_APP_API_BASE_URL");
  if (explicit) return explicit;

  const defaultApiBaseUrl = readEnv("REACT_APP_DEFAULT_API_BASE_URL", "https://api.burosoul.ru");
  const localApiBaseUrl = readEnv("REACT_APP_LOCAL_API_BASE_URL", "http://localhost:8080");

  if (typeof window === "undefined") {
    return defaultApiBaseUrl;
  }

  const host = (window.location.hostname || "").replace(/^www\./i, "");

  // react-snap prerenders production routes from localhost, but it must still
  // talk to the production API; otherwise snapshots are generated from an empty
  // local backend and pages become blank/static-error shells.
  if (isReactSnapRuntime()) return defaultApiBaseUrl;

  // Development sessions on localhost still point to the local backend.
  if (isLocalHost(host) && !IS_PROD_BUILD) return localApiBaseUrl;

  return defaultApiBaseUrl;
}

function normalizeBaseUrl(value, fallback = "") {
  const raw = String(value || fallback || "").trim();
  if (!raw) return "";
  try {
    return new URL(raw, getCurrentOrigin() || "https://burosoul.ru").origin.replace(/\/+$/, "");
  } catch {
    return String(fallback || "").replace(/\/+$/, "");
  }
}

export const API_BASE_URL = normalizeBaseUrl(guessApiBaseUrl(), "https://api.burosoul.ru");

// BASE_URL is used to resolve public assets that may be served by backend (e.g. /images/..)
// If not provided, we fall back to API_BASE_URL.
export const BASE_URL = normalizeBaseUrl(readEnv("REACT_APP_BASE_URL"), API_BASE_URL);

export const WEB_PUSH_PUBLIC_KEY = readEnv("REACT_APP_WEB_PUSH_PUBLIC_KEY");
export const APP_VERSION = readEnv("REACT_APP_VERSION", "dev");
export const QUASAR_INTEGRATION_ENABLED = readBoolEnv("REACT_APP_ENABLE_QUASAR", false);

function guessFinanceEnabled() {
  const explicit = readEnv("REACT_APP_ENABLE_FINANCE");
  if (explicit) {
    return readBoolEnv("REACT_APP_ENABLE_FINANCE", false);
  }

  if (typeof window === "undefined") {
    return !IS_PROD_BUILD;
  }

  const host = String(window.location.hostname || "").replace(/^www\./i, "").toLowerCase();
  if (isLocalHost(host)) return true;

  return host !== "burosoul.ru";
}

export const FINANCE_SECTION_ENABLED = guessFinanceEnabled();
